<template>
  <FriedModalSubContainer>
    <template #header>
      <FriedModalHeader :header="$t('dr_room_name_and_collaborators')" />
    </template>
    <FriedParagraph class="description">
      {{ $t('dr_you_can_always_change_this_in_settings_later.') }}
    </FriedParagraph>
    <div class="name-and-company-inputs">
      <FriedInput
        v-model.trim="name"
        autofocus
        data-external="dsr-naming-modal-room-name-input"
        :label="$t('room_name_label')"
        @keyup.enter="!!name && $emit('create-room', { name, companyName, collaborators })"
      />
      <FriedInput
        v-model.trim="companyName"
        data-external="dsr-naming-modal-room-company-input"
        :label="$t('company_optional_label')"
        @keyup.enter="!!name && $emit('create-room', { name, companyName, collaborators })"
      />
      <Collaborators @update-collaborators="collaborators = $event" />
    </div>
    <template #footer>
      <FriedModalButtonsFooter>
        <FriedButton
          v-if="showBackButton"
          :button-type="ButtonType.Secondary"
          data-external="dsr-naming-modal-back-button"
          @click="$emit('back')"
        >
          {{ $t('back_button') }}
        </FriedButton>
        <FriedButton
          :class="['create-button', { disabled: !name }]"
          :disabled="!name"
          data-external="dsr-naming-modal-continue-button"
          @click="$emit('create-room', { name, companyName, collaborators })"
        >
          {{ $t('continue_button') }}
        </FriedButton>
      </FriedModalButtonsFooter>
    </template>
  </FriedModalSubContainer>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { ButtonType } from '@getaccept/fried-tofu';
import Collaborators from './Collaborators.vue';

export default defineComponent({
  components: {
    Collaborators,
  },
  props: {
    templateName: {
      type: String,
      default: null,
    },
    showBackButton: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['create-room', 'back'],
  setup(props) {
    const name = ref(props.templateName || '');
    const companyName = ref('');
    const collaborators = ref([]);

    return {
      name,
      companyName,
      ButtonType,
      collaborators,
    };
  },
});
</script>

<style lang="scss" scoped>
.name-and-company-inputs {
  display: flex;
  flex-direction: column;
  margin-top: var(--spacing-100);
  gap: var(--spacing-25);
}

.description {
  margin-top: var(--spacing-100);
}

.create-button.disabled {
  cursor: not-allowed;
}
</style>
